export default __webpack_public_path__ + "static/media/picture-1.29e9d279.svg";